import React from 'react'
import { Route, BrowserRouter as Router, Routes, Link  } from 'react-router-dom';
import config from '../Config';

export const SalesMaterialsSec = () => {
  return (
    <>
    <section className='security-bx '>
        <div className='container'>
            <div className='row'>
                <div className='col-md-12'>
                    <div className='sellsheet'>
                        <ul>
                            <li>
                              <div className='sellsheet-lft'><img src={`${config.siteBaseUrl}/assets/imgs/sheet-icon1.svg`} alt='' /> <span>Issuing Sell Sheet</span></div>
                              <div className='sellsheet-rgt'>
                                <div className='sell-lang'>
                                  <ul>
                                    <li><Link to={`${config.siteBaseUrl}/assets/pdf/English/TCB Pay Issuing EN.pdf`} target='_blank'>EN</Link></li>
                                    <li><Link to={`${config.siteBaseUrl}/assets/pdf/Spanish/TCB Pay Issuing ES.pdf`} target='_blank'>ES</Link></li>
                                    <li><Link to={`${config.siteBaseUrl}/assets/pdf/French/TCB Pay Issuing FR.pdf`} target='_blank'>FR</Link></li>
                                  </ul>
                                </div>
                              </div>
                            </li>
                            <li>
                              <div className='sellsheet-lft'><img src={`${config.siteBaseUrl}/assets/imgs/sheet-icon2.svg`} alt='' className='icn27' /> <span>Portal Sell Sheet</span></div>
                              <div className='sellsheet-rgt'><div className='sell-lang'>
                                  <ul>
                                    <li><Link to={`${config.siteBaseUrl}/assets/pdf/English/TCB Pay Portal EN.pdf`} target='_blank'>EN</Link></li>
                                    <li><Link to={`${config.siteBaseUrl}/assets/pdf/Spanish/TCB Pay Portal ES.pdf`} target='_blank'>ES</Link></li>
                                    <li><Link to={`${config.siteBaseUrl}/assets/pdf/French/TCB Pay Portal FR.pdf`} target='_blank'>FR</Link></li>
                                  </ul>
                                </div></div>
                            </li>
                            <li>
                              <div className='sellsheet-lft'><img src={`${config.siteBaseUrl}/assets/imgs/sheet-icon3.svg`} alt='' /> <span>White-Label Sell Sheet</span></div>
                              <div className='sellsheet-rgt'><div className='sell-lang'>
                                  <ul>
                                    <li><Link to={`${config.siteBaseUrl}/assets/pdf/English/TCB Pay While-Label EN.pdf`} target='_blank'>EN</Link></li>
                                    <li><Link to={`${config.siteBaseUrl}/assets/pdf/Spanish/TCB Pay While-Label ES.pdf`} target='_blank'>ES</Link></li>
                                    <li><Link to={`${config.siteBaseUrl}/assets/pdf/French/TCB Pay While-Label FR.pdf`} target='_blank'>FR</Link></li>
                                  </ul>
                                </div></div>
                            </li>
                            <li>
                              <div className='sellsheet-lft'><img src={`${config.siteBaseUrl}/assets/imgs/sheet-icon4.svg`} alt='' /> <span>TCB Pay App Sell Sheet</span></div>
                              <div className='sellsheet-rgt'><div className='sell-lang'>
                                  <ul>
                                    <li><Link to={`${config.siteBaseUrl}/assets/pdf/English/TCB Pay App EN.pdf`} target='_blank'>EN</Link></li>
                                    <li><Link to={`${config.siteBaseUrl}/assets/pdf/Spanish/TCB Pay App ES.pdf`} target='_blank'>ES</Link></li>
                                    <li><Link to={`${config.siteBaseUrl}/assets/pdf/French/TCB Pay App FR.pdf`} target='_blank'>FR</Link></li>
                                  </ul>
                                </div></div>
                            </li>
                            <li>
                              <div className='sellsheet-lft'><img src={`${config.siteBaseUrl}/assets/imgs/sheet-icon5.svg`} alt='' /> <span>High-Risk Specialists Sell Sheet</span></div>
                              <div className='sellsheet-rgt'><div className='sell-lang'>
                                  <ul>
                                    <li><Link to={`${config.siteBaseUrl}/assets/pdf/English/TCB Pay High Risk EN.pdf`} target='_blank'>EN</Link></li>
                                    <li><Link to={`${config.siteBaseUrl}/assets/pdf/Spanish/TCB Pay High Risk ES.pdf`} target='_blank'>ES</Link></li>
                                    <li><Link to={`${config.siteBaseUrl}/assets/pdf/French/TCB Pay High Risk FR.pdf`} target='_blank'>FR</Link></li>
                                  </ul>
                                </div></div>
                            </li>
                            <li>
                              <div className='sellsheet-lft'><img src={`${config.siteBaseUrl}/assets/imgs/sheet-icon6.svg`} alt='' /> <span>Banking as a Service Sell Sheet</span></div>
                              <div className='sellsheet-rgt'><div className='sell-lang'>
                                  <ul>
                                    <li><Link to={`${config.siteBaseUrl}/assets/pdf/English/TCB Pay Banking as a Service EN.pdf`} target='_blank'>EN</Link></li>
                                    <li><Link to={`${config.siteBaseUrl}/assets/pdf/Spanish/TCB Pay Banking as a Service ES.pdf`} target='_blank'>ES</Link></li>
                                    <li><Link to={`${config.siteBaseUrl}/assets/pdf/French/TCB Pay Banking as a Service FR.pdf`} target='_blank'>FR</Link></li>
                                  </ul>
                                </div></div>
                            </li>
                            <li>
                              <div className='sellsheet-lft'><img src={`${config.siteBaseUrl}/assets/imgs/sheet-icon7.svg`} alt='' className='icn32' /> <span>Become an Agent Sell Sheet</span></div>
                              <div className='sellsheet-rgt'><div className='sell-lang'>
                                  <ul>
                                    <li><Link to={`${config.siteBaseUrl}/assets/pdf/English/Agent Sell Sheet-TCB Pay.pdf`} target='_blank'>EN</Link></li>
                                    <li><Link to={`${config.siteBaseUrl}/assets/pdf/Spanish/TCB Pay Agent ES.pdf`} target='_blank'>ES</Link></li>
                                    <li><Link to={`${config.siteBaseUrl}/assets/pdf/French/TCB Pay Agent FR.pdf`} target='_blank'>FR</Link></li>
                                  </ul>
                                </div></div>
                            </li>

                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <img src={`${config.siteBaseUrl}/assets/imgs/blue-lowerdots.svg`}  alt="" className="orng-dots" />
    </section>
    </>
  )
}
